// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__Udqcl","title":"Alert_title__WmnxH","text":"Alert_text__VgCdN","button":"Alert_button__Y5+ed"};